const PAINS = [
  {
    mark: '!',
    title: '突然アカウントが止まる',
    body: '扱っている素材を理由に、ある日突然データが開けなくなる。',
    tone: 'bg-red-50 text-red-500',
  },
  {
    mark: '⌁',
    title: 'アップロードが終わらない',
    body: '数GBの納品データを送るだけで、作業が一日止まる。',
    tone: 'bg-amber-50 text-amber-600',
  },
  {
    mark: '↗',
    title: '共有リンクが埋もれる',
    body: 'チャットに流れたリンクを、相手が見つけられない。',
    tone: 'bg-orange-50 text-primary',
  },
] as const

export function LandingPain() {
  return (
    <section className="border-t border-border bg-white">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
          動画を送るたびに、困っていませんか？
        </h2>
        <p className="mt-3 text-muted-foreground leading-relaxed">
          テラファイル便は、大容量の動画を扱う現場の困りごとから生まれました。
        </p>
        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {PAINS.map((pain) => (
            <article key={pain.title} className="rounded-2xl border border-border bg-muted/35 p-6">
              <span
                className={`flex size-11 items-center justify-center rounded-xl text-xl font-black ${pain.tone}`}
              >
                {pain.mark}
              </span>
              <h3 className="mt-5 text-base font-bold">{pain.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{pain.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
